import Factory from "@Shared/Factory";
import api from "..";
export const unwrapChosenPackageItem = (datum) => {
    if (!datum || typeof datum !== "object") {
        return null;
    }
    const record = datum;
    if (record.item !== undefined && typeof record.item === "object") {
        return record.item;
    }
    return record;
};
const collectChosenPackages = (packages, data) => {
    if (Array.isArray(data)) {
        for (const datum of data) {
            const unwrapped = unwrapChosenPackageItem(datum);
            if (unwrapped) {
                packages.push(unwrapped);
            }
        }
        return;
    }
    if (!data || typeof data !== "object") {
        return;
    }
    const items = data.items ?? [];
    for (const datum of items) {
        const unwrapped = unwrapChosenPackageItem(datum);
        if (unwrapped) {
            packages.push(unwrapped);
        }
    }
};
const fetchAllChosenPackages = async (url, params = {}) => {
    const packages = [];
    const fetchPage = async (pageUrl, pageParams = {}) => {
        const { data } = await api.get(pageUrl, { params: pageParams });
        collectChosenPackages(packages, data);
        const next = data && typeof data === "object" && !Array.isArray(data)
            ? data.links?.next
            : undefined;
        if (next) {
            await fetchPage(next);
        }
    };
    await fetchPage(url, params);
    return packages;
};
export const getList = async (supplierId, page = 1, inclDel = false, limit = 10, filters = {}) => {
    const params = { inclDel, page, limit };
    if (filters.search)
        params.search = filters.search;
    if (filters.status)
        params.status = filters.status;
    if (filters.network)
        params.network = filters.network;
    if (filters.sort)
        params.sort = filters.sort;
    const { data } = await api.get(`/suppliers/${supplierId}/predict-instant/chosen`, { params });
    if (data && typeof data === "object" && "packages" in data) {
        const response = data;
        return {
            totalPages: response.totalPages ?? 1,
            packages: Array.isArray(response.packages) ? response.packages : [],
        };
    }
    const packages = await fetchAllChosenPackages(`/suppliers/${supplierId}/predict-instant/chosen`, { inclDel });
    return {
        totalPages: 1,
        packages,
    };
};
export const getAll = async (supplierId, inclDel = false) => fetchAllChosenPackages(`/suppliers/${supplierId}/predict-instant/chosen`, {
    inclDel,
});
export const findRaw = (supplierId, packageId, inclDel = false) => api
    .get(`/suppliers/${supplierId}/predict-instant/chosen/${packageId}`, {
    params: { inclDel },
})
    .then((result) => {
    const unwrapped = unwrapChosenPackageItem(result.data?.item ?? result.data);
    if (!unwrapped) {
        throw new Error("Chosen package not found");
    }
    return unwrapped;
});
export const find = (supplierId, packageId, inclDel = false) => api
    .get(`/suppliers/${supplierId}/predict-instant/chosen/${packageId}`, {
    params: { inclDel },
})
    .then((result) => Factory.GeneratedPackage(unwrapChosenPackageItem(result.data?.item ?? result.data)));
export const updateStatus = (supplierId, packageId, status) => api
    .put(`/suppliers/${supplierId}/predict-instant/chosen/${packageId}/status`, { status })
    .then((result) => {
    const unwrapped = unwrapChosenPackageItem(result.data?.item ?? result.data);
    if (!unwrapped) {
        throw new Error("Failed to update chosen package status");
    }
    return unwrapped;
});
